import React from "react";
import ReactDom from "react-dom";
import CountdownBannerApp from "./CountdownBannerApp.jsx";

export default function renderCountdownBanner() {
  document
    .querySelectorAll(".js-countdown-banner__mount")
    .forEach((mount, i) => {
      const data = JSON.parse(mount.dataset.model || {});
      const dictionary = JSON.parse(mount.dataset.dictionary) || null;

      const sessionId = window.sessionStorage.getItem("countdown-banner");

      // do not show the banner if the user has closed it.
      if (sessionId && sessionId === data.id) {
        return;
      }

      mount.classList.add("show-banner");

      ReactDom.render(
        <CountdownBannerApp dictionary={dictionary} {...data} />,
        mount,
      );
    });
}
